import { render, staticRenderFns } from "./StockInfoBase.vue?vue&type=template&id=15a6181c&scoped=true"
import script from "./StockInfoBase.vue?vue&type=script&lang=js"
export * from "./StockInfoBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a6181c",
  null
  
)

export default component.exports